



































































  import { Component, Mixins } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import { SnpMapping, UserInformations } from '@/services/connecteur'
  import SnpMappingDisplay from '@/components/SnpMapping/SnpMappingDisplay.vue'
import snpMappingModule from '@/store/modules/SnpMappingModule'
import serviceModule from '@/store/modules/ServiceModule'

@Component({
  components: {
    SnpMappingDisplay
  }
})
export default class SnpMappingList extends Mixins(BaseVue) {
  public snpList: UserInformations[] = []
  public snpMappingList: SnpMapping[] = []
  public selectedSnpMapping: SnpMapping = new SnpMapping()
  public loading = false
  public searchText = ''
  public dialog = false
  public headers: any[] = [
    { text: this.$t('snpMapping.fl1'), value: 'familyLevelOne' },
    { text: this.$t('snpMapping.plant'), value: 'plant' },
    { text: this.$t('snpMapping.snp'), value: 'snpId' },
    { text: this.$t('snpMapping.minForRequest'), value: 'minForRequest' },
    { text: this.$t('snpMapping.actions'), align: 'center', value: 'actions' }
  ]

  async mounted () {
    try {
      this.loading = true
      this.snpMappingList = await snpMappingModule.getSnpMappings()
      this.snpList = await serviceModule.userApi.getAllSNPs()
    } catch (error) {
      this.displayError(error)
    }
    this.loading = false
  }

  public showDialog (snpMapping?: SnpMapping) {
      if (snpMapping) {
        this.selectedSnpMapping = new SnpMapping(snpMapping)
      } else {
        this.selectedSnpMapping = new SnpMapping()
      }
      this.dialog = true
    }

    public getSnp(snpId: number): string {
      const snps = this.snpList.filter(s => s.id === snpId)
      if (snps.length) {
        return snps[0].fullName || '-'
      }
      return '-'
    }

    public onModalClosed() {
      this.dialog = false
    }

    public get perPageOptions () {
      return JSON.parse(`${process.env.VUE_APP_PER_PAGE_OPTIONS}`)
    }
  }
